class UpsellsCart extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.startX = 0;
    this.endX = 0;
  }

  connectedCallback() {
    this.slidesContainer = this.querySelector('.slides');
    this.slides = this.querySelectorAll('.slide');
    this.prevButton = this.querySelector('.prev');
    this.nextButton = this.querySelector('.next');
    this.haveUpsellsInCart();

    this.prevButton.addEventListener('click', () => this.showSlide(this.currentIndex - 1));
    this.nextButton.addEventListener('click', () => this.showSlide(this.currentIndex + 1));

    this.slidesContainer.addEventListener('touchstart', (e) => this.onTouchStart(e));
    this.slidesContainer.addEventListener('touchend', (e) => this.onTouchEnd(e));

    this.showSlide(this.currentIndex);
  }

  onTouchStart(e) {
    this.startX = e.touches[0].clientX;
  }

  onTouchEnd(e) {
    this.endX = e.changedTouches[0].clientX;
    if (this.startX > this.endX + 50) {
      this.showSlide(this.currentIndex + 1);
    } else if (this.startX < this.endX - 50) {
      this.showSlide(this.currentIndex - 1);
    }
  }

  haveUpsellsInCart() {
   const haveUpsellsInCart = this.slides.length > 0;
   if (!haveUpsellsInCart) {
     this.style.display = 'none'; 
   }
  }

  showSlide(index) {
    this.currentIndex = (index + this.slides.length) % this.slides.length;
    const offset = -this.currentIndex * 100; // Décale la vue
    this.slidesContainer.style.transform = `translateX(${offset}%)`;
  }
}

customElements.define('upsells-cart', UpsellsCart);